import {
    GET_LOGGEDIN_USER,
    GET_USER,
    SET_LOADING,
    SET_IS_ADMIN,
    SET_IS_SUPER,
    SET_USERTYPE,
    UNSET_LOADING,
    SET_SIDEBAR,
    SET_USER,
    SET_NOTIFICATIONS,
    GET_KYC_DATA,
    GET_KYB_DATA,
    GET_VERIFICATION_DATA,
    GET_APIKEY,
    GET_DEVICES,
    SET_OWNER_ITEMS,
    SET_SIGNATORY_ITEMS,
    GET_STATES,
    GET_CITIES,
    GET_LGAS,
    GET_OWNER_STATES,
    GET_OWNER_CITIES,
    GET_OWNER_LGAS,
    GET_INDUSTRIES,
    GET_SUB_INDUSTRIES,
    GET_COUNTRY,
} from '../types';


const reducer = (state: any, action: any) => {

    switch (action.type) {

        case GET_LOGGEDIN_USER:
            return {
                ...state,
                user: action.payload,
                loading: false
            }
        case GET_USER:
            return {
                ...state,
                getuser: action.payload,
                loading: false
            }
        case GET_APIKEY:
            return {
                ...state,
                apikey: action.payload,
                loading: false
            }
        case GET_KYC_DATA:
            return {
                ...state,
                KYCData: action.payload,
                loading: false
            }
        case GET_KYB_DATA:
            return {
                ...state,
                KYBData: action.payload,
                loading: false
            }
        case GET_VERIFICATION_DATA:
            return {
                ...state,
                verification: action.payload,
                loading: false
            }
        case GET_DEVICES:
            return {
                ...state,
                devices: action.payload,
                loading: false
            }
        case SET_USER:
            return {
                ...state,
                user: action.payload,
                loading: false
            }
        case SET_USERTYPE:
            return {
                ...state,
                userType: action.payload,
                loading: false
            }
        case SET_SIDEBAR:
            return {
                ...state,
                sidebar: action.payload,
                loading: false
            }
        case SET_IS_SUPER:
            return {
                ...state,
                isSuper: action.payload,
                loading: false
            }
        case SET_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.payload,
                loading: false
            }
        case SET_IS_ADMIN:
            return {
                ...state,
                isAdmin: action.payload,
                loading: false
            }
        case SET_OWNER_ITEMS:
            return {
                ...state,
                ownerItems: action.payload,
                loading: false
            }
        case SET_SIGNATORY_ITEMS:
            return {
                ...state,
                signatoryItems: action.payload,
                loading: false
            }
        case GET_COUNTRY:
            return {
                ...state,
                countries: action.payload,
                loading: false
            }
        case GET_STATES:
            return {
                ...state,
                states: action.payload,
                loading: false
            }
        case GET_CITIES:
            return {
                ...state,
                cities: action.payload,
                loading: false
            }
        case GET_LGAS:
            return {
                ...state,
                lgas: action.payload,
                loading: false
            }
        case GET_OWNER_STATES:
            return {
                ...state,
                ownerStates: action.payload,
                loading: false
            }
        case GET_OWNER_CITIES:
            return {
                ...state,
                ownerCities: action.payload,
                loading: false
            }
        case GET_OWNER_LGAS:
            return {
                ...state,
                ownerLgas: action.payload,
                loading: false
            }
        case GET_INDUSTRIES:
            return {
                ...state,
                industries: action.payload,
                loading: false
            }
        case GET_SUB_INDUSTRIES:
            return {
                ...state,
                subIndustries: action.payload,
                loading: false
            }
        case SET_LOADING:
            return {
                ...state,
                loading: true
            }

        case UNSET_LOADING:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }

}

export default reducer;